<template>
  <a-layout id="components-layout-demo-fixed-sider">
    <a-layout-sider
      :style="{ overflow: 'auto', height: '100vh', position: 'fixed', left: 0 }"
    >
      <div class="logo">
        <GithubOutlined class="logo-img" />
        <a
          class="logo-text"
          href="https://github.com/huanggm/use-vue-service"
          target="_blank"
        >
          use-vue-service
        </a>
      </div>
      <a-menu theme="dark" mode="inline" v-model:selectedKeys="selectedKeys">
        <a-menu-item key="1">
          <user-outlined />
          <router-link to="/">简介</router-link>
        </a-menu-item>
        <a-menu-item key="2">
          <ContainerOutlined />
          <router-link to="/api">API 介绍</router-link>
        </a-menu-item>
        <a-menu-item key="3">
          <ToolOutlined />
          <router-link to="/starter">快速搭建项目</router-link>
        </a-menu-item>
        <a-menu-item key="4">
          <ApartmentOutlined />
          <router-link to="/message">组件间通信</router-link>
        </a-menu-item>
        <a-menu-item key="5">
          <BlockOutlined />
          <router-link to="/about">Vue、React和Angular对比</router-link>
        </a-menu-item>
        <a-menu-item key="6">
          <BlockOutlined />
          <router-link to="/library">常见库理解</router-link>
        </a-menu-item>
        <a-menu-item key="7">
          <BellOutlined />
          <router-link to="/todo">Todo</router-link>
        </a-menu-item>
        <a-menu-item key="8">
          <MailOutlined />
          <router-link to="/hacknews">HackNews</router-link>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout :style="{ marginLeft: '200px' }">
      <a-layout-content>
        <div
          :style="{
            padding: '24px',
            background: '#fff',
            minHeight: 'calc(100vh - 70px)'
          }"
        >
          <router-view />
        </div>
      </a-layout-content>
      <a-layout-footer :style="{ textAlign: 'center' }">
        Ant Design ©2018 Created by Ant UED
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>
<script>
import {
  UserOutlined,
  GithubOutlined,
  BlockOutlined,
  ApartmentOutlined,
  BellOutlined,
  MailOutlined,
  ContainerOutlined,
  ToolOutlined
} from "@ant-design/icons-vue";

export default {
  data() {
    return {
      selectedKeys: ["4"]
    };
  },
  components: {
    UserOutlined,
    GithubOutlined,
    BlockOutlined,
    ApartmentOutlined,
    BellOutlined,
    MailOutlined,
    ContainerOutlined,
    ToolOutlined
  }
};
</script>

<style lang="scss">
#components-layout-demo-fixed-sider .logo {
  height: 32px;
  line-height: 32px;
  background: #fff;
  border-radius: 4px;
  margin: 16px;

  .logo-img {
    font-size: 18px;
    line-height: 32px;
    margin-left: 5px;
  }

  .logo-text {
    font-size: 16px;
  }
}

#components-layout-demo-fixed-sider .ant-menu-item > a {
  display: inline;
}
</style>
